module.exports = function (str) {
    return str.toLowerCase().replace(/^.|\s\S/g, function (a) {
        return a.toUpperCase();
    });
};
